const state = {
  isMusicPlayerActive: false,
  isBuildingInfoActive: false,
  isOwnerInfoActive: false,
  isCalendarActive: false,
  isGuideWindowActive: false
}

export const getters = {
  isMusicPlayerActive: state => state.isMusicPlayerActive,
  isBuildingInfoActive: state => state.isBuildingInfoActive,
  isOwnerInfoActive: state => state.isOwnerInfoActive,
  isCalendarActive: state => state.isCalendarActive,
  isGuideWindowActive: state => state.isGuideWindowActive
}

export const actions = {
  setMusicPlayerActive ({ commit }, value) {
    commit('SET_MUSIC_PLAYER_ACTIVE', value)
  },
  setBuildingInfoActive ({ commit }, value) {
    commit('SET_BUILDING_INFO_ACTIVE', value)
  },
  setOwnerInfoActive ({ commit }, value) {
    commit('SET_OWNER_INFO_ACTIVE', value)
  },
  setCalendarActive ({ commit }, value) {
    commit('SET_CALENDAR_ACTIVE', value)
  },
  setGuideWindowActive ({ commit }, value) {
    commit('SET_GUIDE_WINDOW_ACTIVE', value)
  }
}

export const mutations = {
  SET_BUILDING_INFO_ACTIVE (state, bool = false) {
    state.isBuildingInfoActive = bool
  },
  SET_MUSIC_PLAYER_ACTIVE (state, bool = false) {
    state.isMusicPlayerActive = bool
  },
  SET_OWNER_INFO_ACTIVE (state, bool = false) {
    state.isOwnerInfoActive = bool
  },
  SET_CALENDAR_ACTIVE (state, bool = false) {
    state.isCalendarActive = bool
  },
  SET_GUIDE_WINDOW_ACTIVE (state, bool = false) {
    state.isGuideWindowActive = bool
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
